export default __webpack_public_path__ + "static/media/027-read.f965f62f.svg";